// extracted by mini-css-extract-plugin
module.exports = {"root":"ToolboxQuestionsEditor_root__BACjZ","cardLeft":"ToolboxQuestionsEditor_cardLeft__xbrO9","cardRight":"ToolboxQuestionsEditor_cardRight__asj2Z"};